const featureFlags = {
  isInfrontEnabled: process.env.NEXT_PUBLIC_IS_INFRONT_ENABLED === "true",
  isPOAEnabled: process.env.NEXT_PUBLIC_IS_POA_ENABLED === "true",
};

export default featureFlags;
